import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * تهيئة قواعد البيانات للمحادثات والملاحظات
 */
export const initializeTeamCommunication = async () => {
  try {
    // إنشاء مستند تهيئة للمحادثات
    const chatInitRef = doc(db, 'system', 'chatInit');
    const chatInitDoc = await getDoc(chatInitRef);
    
    if (!chatInitDoc.exists()) {
      await setDoc(chatInitRef, {
        initialized: true,
        createdAt: new Date(),
        version: '3.0'
      });
      console.log('Chat system initialized');
    }

    // إنشاء مستند تهيئة للملاحظات
    const noteInitRef = doc(db, 'system', 'noteInit');
    const noteInitDoc = await getDoc(noteInitRef);
    
    if (!noteInitDoc.exists()) {
      await setDoc(noteInitRef, {
        initialized: true,
        createdAt: new Date(),
        version: '3.0'
      });
      console.log('Note system initialized');
    }

    // إنشاء مستند تهيئة للإشعارات
    const notificationInitRef = doc(db, 'system', 'notificationInit');
    const notificationInitDoc = await getDoc(notificationInitRef);
    
    if (!notificationInitDoc.exists()) {
      await setDoc(notificationInitRef, {
        initialized: true,
        createdAt: new Date(),
        version: '3.0'
      });
      console.log('Notification system initialized');
    }

    return true;
  } catch (error) {
    console.error('Error initializing team communication:', error);
    return false;
  }
};

/**
 * تحديث قواعد Firebase مؤقتاً
 */
export const updateFirebaseRules = async () => {
  try {
    // هذه دالة مؤقتة لتحديث القواعد
    // في الإنتاج، يجب استخدام Firebase CLI أو Firebase Admin SDK
    console.log('Firebase rules need to be updated manually');
    console.log('Please run: firebase deploy --only firestore:rules');
    
    return true;
  } catch (error) {
    console.error('Error updating Firebase rules:', error);
    return false;
  }
};

/**
 * التحقق من صلاحيات المستخدم
 */
export const checkUserPermissions = async (userId: string) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      return {
        canCreateChats: true,
        canCreateNotes: true,
        canSendMessages: true,
        role: userData.role || 'employee'
      };
    }
    
    return {
      canCreateChats: false,
      canCreateNotes: false,
      canSendMessages: false,
      role: 'guest'
    };
  } catch (error) {
    console.error('Error checking user permissions:', error);
    return {
      canCreateChats: false,
      canCreateNotes: false,
      canSendMessages: false,
      role: 'guest'
    };
  }
};

export default {
  initializeTeamCommunication,
  updateFirebaseRules,
  checkUserPermissions
};
